import React from 'react'

const About = () => {
    return (
        <div className='text-center' style={{marginTop:"15%"}}>
            <h2 className='text-danger'>I'm Erhan. I'm a web developer.</h2>
        </div>
    )
}

export default About